import React, { createContext, useReducer } from "react";
import Reducer from "./reducer";
import initialState from "core/store/initialState";

/**
 * This is our global store
 * we follow redux priciples and create one store only
 * Please notice that we're not using react-redux here at all
 * we just utilize the current react hooks tools (mainly we use the context provider) in order to create
 * global store. Take a look at App.js file there we use this Store
 * @param {} children
 */
const Store = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState); // create initial state

  return (
    <Context.Provider value={[state, dispatch]}>{children}</Context.Provider>
  );
};

// here we create a context for our store
// so we can pass it to all child components
export const Context = createContext(initialState);
export default Store;
